import ManualCheck from "./ManualCheck";

export default ManualCheck;
